import React from 'react'
import { createMuiTheme } from '@material-ui/core'

export default createMuiTheme({
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
    h1: {
      fontSize: '2.875rem',
      fontFamily: '"Times New Roman", Times, serif',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.5rem',
      fontFamily: '"Times New Roman", Times, serif',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontFamily: '"Times New Roman", Times, serif',
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: '1.1rem',
      fontFamily: '"Times New Roman", Times, serif',
      fontWeight: 350,
    },
    button: {
      fontSize: '1.125rem',
      fontFamily: '"Times New Roman", Times, serif',
    },
    body1: {
      fontFamily: '"Times New Roman", Times, serif',
      fontSize: '1rem',
      lineHeight: 1.375,
    },
  },
})
